import React from 'react';
import { injectIntl } from 'react-intl';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import Upload from 'react-icons/lib/fa/upload';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';

import Alert from './Alert'
import { camelize } from '../../../../shared/utilities';
import { defaultMessages } from '../../../../libs/i18n/default';

class ResidentPoliceVettingUpload extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      page: this.props.page,
      showModal: false,
      submitted: false,
      police_vetting_form: null,
      primary_identification: null,
      secondary_identification: null,
    }

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.loadingAnimation = this.loadingAnimation.bind(this);
    this.handleFileSelection = this.handleFileSelection.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  checkFormValid() {
    return (
      this.state.police_vetting_form != null &&
      this.state.primary_identification != null &&
      this.state.secondary_identification != null
    )
  }

  loadingAnimation() {
    if (this.state.submitted) {
      return (<i className='fa fa-spinner fa-spin fa-lg fa-fw'></i>)
    }
  }

  handleFileSelection(e) {
    this.setState({ [e.target.name]: e.target.files[0] })
  }

  handleSubmit(e) {
    e.preventDefault()

    let payload = {
      form: {
        authenticity_token: ReactOnRails.authenticityToken(),
        resident_id: this.props.resident.id,
        host_id: this.props.user.host.id,
        attachments: [
          {
            name: `Police Vetting Form - ${this.props.resident.name}`,
            kind: `police_vetting_form`,
            file: this.state.police_vetting_form
          },
          {
            name: `Primary Identification - ${this.props.resident.name}`,
            kind: `primary_identification`,
            file: this.state.primary_identification
          },
          {
            name: `Secondary Identification - ${this.props.resident.name}`,
            kind: `secondary_identification`,
            file: this.state.secondary_identification
          },
        ]
      }
    }

    this.setState({ submitted: true })

    this.props.onPoliceVettingFormSubmit(payload)
  }

  render() {
    const { formatMessage } = this.props.intl;
    const LoadingAnimation = this.loadingAnimation()
    const certificate_types = ["police_vetting_form", "primary_identification", "secondary_identification"]

    return (
      <>
        <small>Please upload police vetting forms.</small>
        <Button bsSize="xsmall" onClick={this.open}>
          <Upload /> Police Vetting
        </Button>
        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Police Vetting Forms</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit}>
              <Alert alert={formatMessage(defaultMessages.clientHostPagesResidentsInfoPoliceVetting)} />
              {certificate_types.map(type => {
                const label = camelize(`clientHostPagesResidentsLabels ${type.replace(/_/g, " ")}`)
                const tooltip = defaultMessages[camelize(`clientHostPagesResidentsTooltips ${type.replace(/_/g, " ")}`)]

                return (
                  <>
                    {tooltip ? (
                      <div style={{ paddingBottom: 5 }}>
                        <ControlLabel>{formatMessage(defaultMessages[label])}</ControlLabel>
                        <small style={{ display: "block" }}>{formatMessage(tooltip)}</small>
                      </div>
                    ) : (
                      <ControlLabel>{formatMessage(defaultMessages[label])}</ControlLabel>
                    )}
                    <FormControl
                      type="file"
                      id={type}
                      name={type}
                      className="mb-2"
                      componentClass="input"
                      onChange={this.handleFileSelection}
                    />
                  </>
                )
              })}

              {this.props.uploader.progress && (
                <ProgressBar now={this.props.uploader.progress} label={`${this.props.uploader.progress}%`} active striped />
              )}

              <hr />
              <Button type="submit" id="police-check-submit" className="btn-primary" disabled={this.state.submitted || !this.checkFormValid()}>
                {LoadingAnimation} Upload
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export default injectIntl(ResidentPoliceVettingUpload);
